import React, { useState } from 'react';
import './SourceVerificationPage.scss';
import { Button } from 'primereact/button';
import { forceSourceReverification } from '../../../shared/services/admin/source-verification/AdminSourceVerificationService';

interface SubmitResult {
  success: boolean;
  queuedCount: number;
  totalUrls: number;
}

const SourceVerificationPage: React.FC = () => {
  const [urlsText, setUrlsText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<SubmitResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = () => {
    const urls = urlsText
      .split('\n')
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    if (urls.length === 0) {
      setError('Please enter at least one URL.');
      setResult(null);
      return;
    }

    setIsLoading(true);
    setError(null);
    setResult(null);

    forceSourceReverification(urls)
      .then((response) => {
        setResult(response);
        setIsLoading(false);
      })
      .catch(() => {
        setError('An error occurred while submitting the request. Please try again.');
        setIsLoading(false);
      });
  };

  return (
    <div className="source-verification">
      <div className="source-verification__form">
        <label className="source-verification__label" htmlFor="source-verification-urls">
          URLs to re-verify (one per line)
        </label>
        <textarea
          id="source-verification-urls"
          className="source-verification__textarea"
          value={urlsText}
          onChange={(e) => setUrlsText(e.target.value)}
          placeholder={'https://example.com\nhttps://another-site.com'}
          disabled={isLoading}
        />
        <div className="source-verification__actions">
          <Button
            className="btn btn--sm"
            label="Force Re-verification"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading && <span className="ico--loader ico--xs" />}
          </Button>
        </div>
        {result && (
          <div className="source-verification__feedback source-verification__feedback--success">
            Successfully queued {result.queuedCount} of {result.totalUrls} URLs for re-verification.
          </div>
        )}
        {error && (
          <div className="source-verification__feedback source-verification__feedback--error">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default SourceVerificationPage;
